<template>
    <div class="space-y-4">
        <component :is="resolvedComponent" :add-on="addOn" :value="value" :children="children" :on-change="onChange" />
    </div>
</template>

<script setup>
defineOptions({
    name: 'AddOnItem'
})

import AddOnBoolean from './AddOnBoolean.vue'
import AddOnQuantity from './AddOnQuantity.vue'
import AddOnSelect from './AddOnSelect.vue'

const props = defineProps({
    addOn: {
        type: Object,
        required: true
    },
    value: {
        type: [Number, String, Object, Boolean, null],
        default: null
    },
    getValue: {
        type: Function,
        required: true
    },
    onChange: {
        type: Function,
        required: true
    }
})

const children = computed(() => (Array.isArray(props.addOn?.children) ? props.addOn.children : []))

const resolvedComponent = computed(() => {
    switch (props.addOn?.inputType) {
        case 'quantity':
            return AddOnQuantity
        case 'boolean':
            return AddOnBoolean
        case 'select':
            return AddOnSelect
    }
})
</script>
